import SelectBox from 'devextreme-react/select-box';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { coSoApi } from '../../api/coSoApi';
import { useCommonContext } from '../../contexts/common';
import { pageBaseStatus } from '../../state/pageBaseStatus';
import { coSoActionTypes } from '../../state/reducers/coSoReducer';
const ComboboxCoSo = ({
  value,
  onValueChanged,
  showClearButton,
  is_readonly,
}) => {
  const { translate } = useCommonContext();
  const { status, dm_cosos } = useSelector((x) => x.coSo);
  const dispatch = useDispatch();
  useEffect(() => {
    if (status == pageBaseStatus.is_not_initial) {
      handleReload();
    }
  }, [status]);
  const handleReload = async () => {
    dispatch({ type: coSoActionTypes.LOAD.START })
    const res = await coSoApi.SelectAll();
    if (res.is_success) {
      dispatch({ type: coSoActionTypes.LOAD.SUCCESS, payload: res.data })
    } else {
      dispatch({ type: coSoActionTypes.LOAD.ERROR, payload: res.message })
    }
  };
  return (
    <React.Fragment>
      <SelectBox
        dataSource={dm_cosos}
        displayExpr={'ten_co_so'}
        valueExpr={'id'}
        value={value}
        stylingMode="outlined"
        readOnly={is_readonly === true ? is_readonly : false}
        placeholder={translate('Chọn cơ sở')}
        width="100%"
        showClearButton={showClearButton}
        onValueChanged={(e) => {
          if (e.event) onValueChanged(e.value || 0);
        }}
      />
    </React.Fragment>
  );
};

export default ComboboxCoSo;
